// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3K0GG","content":"RecentSearches_content__3DZUP"};